export function drawerSet(bool) {
	return {
    type: 'DRAWER_SET',
		payload: {
			drawer: bool,
		}
	}
}

export function loadingSet(bool) {
	return {
    type: 'LOADING_SET',
		loading: bool,
	}
}

export function progressSet(visible, percent) {
	console.log('progressAction', percent);
	return {
    type: 'PROGRESS_SET',
		payload: {
			visible: visible,
			percent: percent,
		}
	}
}

export function dialogClose() {
	return {
    type: 'DIALOG_SET',
		payload: {
			visible: false,
			title: '',
			comment: '',
		},
	}
}


export function snackOpen(severity, comment, duration) {
	return {
    type: 'SNACK_SET',
		payload: {
			visible: true,
			severity: severity,
			comment: comment,
			duration: duration,
		},
	}
}

export function snackClose() {
	return {
    type: 'SNACK_SET',
		payload: {
			visible: false,
		},
	}
}

export function popoverOpen(anchorEl, comment) {
	return {
    type: 'POPOVER_SET',
		payload: {
			visible: true,
			anchorEl: anchorEl,
			comment: comment,
		},
	}
}

export function popoverClose() {
	return {
    type: 'POPOVER_SET',
		payload: {
			visible: false,
			anchorEl: null,
			comment: '',
		},
	}
}
